import { EventEmitter, Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PlatformNavService {
  private menuSelectedSubject = new Subject<string>();
  public readonly $menuSelected = this.menuSelectedSubject.asObservable();

  private _isReady = false;
  private _currentSelected: string[] | null = null;

  private navEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private router: Router,
    private ngZone: NgZone,
  ) {
    this.$menuSelected.subscribe((url) => {
      this.ngZone.run(() => {
        this.navigateByUrl(url);
      });
    });
  }

  setNext(path: string) {
    this.menuSelectedSubject.next(path);
  }

  getNavEmitter() {
    return this.navEventEmitter;
  }

  navigate(data: any) {
    console.log('ROUTING TO: ' + data.item.url);
    const url = data.item.url;
    this.navigateByUrl(url);
  }

  navigateByUrl(url: string) {
    const currentRouterUrl = this.router.url;
    let accountId = (environment.userInfo as any)?.accountId;
    const matches = currentRouterUrl.match(/\/accounts\/(.*?)\//);
    if (matches && matches[1]) {
      accountId = matches[1];
    }

    console.log('--- URL: ' + url);
    if (url.indexOf('account-details') >= 0) {
      this.router.navigate(['/accounts', accountId, 'details']);
    } else if (url.indexOf('account-permission-profiles') >= 0) {
      this.router.navigate(['/accounts', accountId, 'permission-profiles']);
    } else if (url.indexOf('account-tag-groups') >= 0) {
      this.router.navigate(['/accounts', accountId, 'tag-groups', 'list']);
    } else if (url.indexOf('account-tag-associations') >= 0) {
      this.router.navigate([
        '/accounts',
        accountId,
        'tag-groups',
        'associations',
      ]);
    } else if (url.indexOf('account-tag-settings') >= 0) {
      this.router.navigate([
        '/accounts',
        accountId,
        'tag-groups',
        'account-settings',
      ]);
    } else if (url.indexOf('account-metadata') >= 0) {
      this.router.navigate(['/accounts', accountId, 'meta', 'list']);
    } else if (url.indexOf('account-api-credentials') >= 0) {
      this.router.navigate([
        '/accounts',
        accountId,
        'credentials',
        'applications',
      ]);
    } else if (url.indexOf('account-reports') >= 0) {
      this.router.navigate(['/accounts', accountId, 'reports']);
    } else if (url.indexOf('account-users') >= 0) {
      this.router.navigate(['/accounts', accountId, 'users']);
    } else if (url.indexOf('account-user-groups') >= 0) {
      this.router.navigate(['/accounts', accountId, 'user-groups']);
    } else if (url.indexOf('account-permission-groups') >= 0) {
      this.router.navigate(['/accounts', accountId, 'groups']);
    } else if (url.indexOf('account-trails') >= 0) {
      this.router.navigate(['/accounts', accountId, 'trails']);
    } else if (url.indexOf('account-settings') >= 0) {
      this.router.navigate(['/accounts', accountId, 'settings']);
    } else if (url.indexOf('all-accounts') >= 0) {
      this.router.navigate(['/accounts']);
    } else if (url.indexOf('all-userprofiles') >= 0) {
      this.router.navigate(['/user-profile']);
    } else if (
      url.indexOf('configuration') >= 0 ||
      url.indexOf('system-information') >= 0
    ) {
      this.router.navigate([url]);
    } else {
      console.log(`Route not Found, Path: ${url}`);
    }
  }

  selectMenu(menu: string[]) {
    window.trustArcPlatformNavigation.selectMenu(menu);
  }
}
